/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useState } from "react";

import { useSimpleEvent } from "../../../../ui/hooks/useSimpleEvent";
import { VIEW_EDITOR_VIEW_MODE, ViewEditorView } from "../ViewEditorView";
import { ViewEditorDebug } from "./ViewEditorDebug";
import { ViewEditorPreview } from "./ViewEditorPreview";

/**
 * Component props
 */
export interface IViewEditorMainContentProps {
	view: ViewEditorView;
}

/**
 * Main Content Component
 *
 * @param props Component props
 */
export const ViewEditorMainContent: React.FunctionComponent<IViewEditorMainContentProps> = ({ view }) => {
	const [ editorMode, setEditorMode ] = useState(() => view.getMode());

	useSimpleEvent(view.onModeChange, () => setEditorMode(view.getMode()), [ view ], true);

	switch (editorMode) {
		case VIEW_EDITOR_VIEW_MODE.DESIGN:
		case VIEW_EDITOR_VIEW_MODE.PREVIEW:
			return <ViewEditorPreview view={view} mode={editorMode} />;
		case VIEW_EDITOR_VIEW_MODE.DEBUG:
			return <ViewEditorDebug view={view} />;
	}
};
